import { Css } from "@homebound/beam";
import { HasChildren } from "src/utils";

export function ObnoxiousText({ children }: HasChildren) {
  return <div css={Css.tac.bgColor("yellow").color("red").xl.p2.br4.$}>{children}</div>;
}
